import { CartMetadata } from 'src/common/interfaces/dtos/ICartMetadata';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { IRetailTransactionSearchCriteria } from '../../common/interfaces/dtos/IRetailTransactionSearchCriteria';
import { store } from '../../common/redux/configure-store';
import { RecallOrderActions } from '../../common/redux/reducers/recall-order-reducer';
import { customerOrderLookup } from './service/customer-order-lookup';

export const recallOrderLookup = async (
  searchCriteria: IRetailTransactionSearchCriteria,
  take?: number,
  skip?: number,
): Promise<CartMetadata[]> => {
  let recallOrderData: CartMetadata[] = [];

  await customerOrderLookup({
    phoneNumber: searchCriteria.PhoneNumber,
    customerId: searchCriteria.CustomerId,
    take: take,
    skip: skip,
  }).then((rawData): void => {
    // Takes rawData and maps it back into useable data for (date) to use helper functions
    const data: CartMetadata[] = rawData.map(r => ({
      orderId: r.orderId,
      beginDateTime: new Date(r.beginDateTime),
      customerName: r.customerName,
      totalAmount: r.totalAmount,
    }));
    if (data.length > 0) {
      sortByDate(data);
      updateRecallOrder(data);
      recallOrderData = data;
    } else {
      if (searchCriteria.CustomerId) {
        const error: IMessageModal = {
          message: 'NoCustomerOrderWasFoundForLoyalty',
          messageArgs: { arg: searchCriteria.CustomerId },
        };
        throw error;
      }
      if (searchCriteria.PhoneNumber) {
        const error: IMessageModal = {
          message: 'NoCustomerOrderWasFoundForPhoneNumber',
          messageArgs: { arg: searchCriteria.PhoneNumber },
        };
        throw error;
      }
    }
  });

  return recallOrderData;
};

const sortByDate = (date: CartMetadata[]): void => {
  date.sort((a, b) => b.beginDateTime.valueOf() - a.beginDateTime.valueOf());
};

const updateRecallOrder = (data: CartMetadata[]): void => {
  store.dispatch(RecallOrderActions.setRecallOrderData(data));
};
